<template>
    <v-snackbar top auto-height v-model="show" color="error" :timeout="5000">
        {{ message }}
        <v-btn dark flat @click="close">
            Close
        </v-btn>
    </v-snackbar>
</template>

<script>
export default {
    name: "Error",
    data: function( ) {
        return {

        }
    },
    computed: {
        show: {
            get( ) {
                return this.$store.state.error.show;
            },
            set( show ) {
                this.$store.dispatch( 'error/hide' );
            }
        },
        message( ) {
            return this.$store.state.error.message;
        }
    },
    methods: {
        close( ) {
            this.$store.dispatch( 'error/hide' );
        }
    }
}
</script>

<style scoped>
</style>
